import AbstractVideoProcessor from './AbstractVideoProcessor';

export default class WebosVideoProcessor extends AbstractVideoProcessor {
  constructor(video1, video2, options) {
    super(video1, video2, options);
    this.bindEvents();
  }

  bindEvents() {
    for (const video of [this.video1, this.video2]) {
      video.muted = true;

      video.onended = () => {
        this.emitter.emit('video:ended', video);
        clearTimeout(this.skipTimeout);
      }

      video.onerror = (error) => {
        this.emitter.emit('video:error', {video, error});
      }

      video.onplay = () => {
        this.emitter.emit('video:play', video);
        this.preloadVideo(video.id === 'video1' ? this.video2 : this.video1, this.nextVideoSrc);
      }
    }
  }

  play(src, nextVideoSrc) {
    this.nextVideoSrc = nextVideoSrc;
    return super.play(src);
  }

  preloadVideo(video, videoSrc) {
    video.src = videoSrc;
    video.load();
  }

  skipVideo(video) {
    if (video.currentTime === 0) {
      const nextVideoElement = this.getOtherVideo();
      this.preloadVideo(nextVideoElement, this.nextVideoSrc);
    }

    video.onended();
    this.stop(video);
  }
}
